import React, { useState, useEffect } from 'react';
import {
  notifySuccess,
  notifyInfo,
  notifyError,
} from '../../../components/Messages/Notification';
import {
  listAdministrator,
  updateAdministrator,
} from '../../../services/AdministratorService';

import AutoCompleteAdministratorEmail from '../../../components/AutoComplete/AutoCompleteAdministratorEmail';
import AutoCompleteAdministratorName from '../../../components/AutoComplete/AutoCompleteAdministratorName';
import SelectSystemCode from '../../../components/Dropdown/SelectSystemCode';
import ClientGrid from '../../../components/ClientGrid/ClientGrid';
import SelectRole from '../../../components/Dropdown/SelectRole';
import Button from '../../../components/Buttons/Button';
import {
  pbDateTime,
  pbDateTimeSorter,
} from '../../../components/ClientGrid/CellRenderer';

export default function AdministratorTable(params) {
  const [rowsChecked, setRowsChecked] = useState([]);
  const [selectedRowsIds, setSelectedRowsIds] = React.useState([]);

  const GridCheckbox = ({
    tableManager,
    value,
    data,
    column,
    colIndex,
    rowIndex,
    onChange,
    disabled,
  }) => {
    const userIds = tableManager.config.additionalProps.header.props.rowsChecked;
    const checkedValue = userIds.includes(data.usrId);
    const rows = tableManager.rowsApi.rows;
    return (
      <div style={{ paddingLeft: 10 }}>
        <input
          key={rowIndex}
          type="checkbox"
          checked={checkedValue}
          disabled={disabled}
          column={column}
          onChange={(event) => {
            const checked = event.target.checked;
            if (checked) {
              updateAdmin(rowIndex - 1, params.id, rows);
            } else {
              updateAdmin(rowIndex - 1, 0, rows);
            }
          }}
        />
      </div>
    );
  };

  const columns = [
    {
      id: 'user',
      width: '35px',
      visible: true,
      cellRenderer: GridCheckbox,
    },
    {
      id: 'name',
      field: 'name',
      label: 'User',
    },
    {
      id: 'roleName',
      field: 'roleName',
      label: 'Role Name',
    },
    {
      id: 'email',
      field: 'email',
      label: 'Email',
      width: '300px',
    },
    {
      id: 'mobileNo',
      field: 'mobileNo',
      label: 'Mobile No',
    },
    {
      id: 'userType',
      field: 'userType',
      label: 'User Type',
    },
    {
      id: 'status',
      field: 'status',
      label: 'Status',
    },
    {
      id: 'authenticationMode',
      field: 'authenticationMode',
      label: 'Authentication Mode',
    },
    {
      id: 'createdAt',
      field: 'createdAt',
      label: 'Created At',
      cellRenderer: pbDateTime,
      sort: pbDateTimeSorter,
      visible: false,
    },
    {
      id: 'modifiedBy',
      field: 'modifiedBy',
      label: 'Modified By',
    },
  ];

  const updateAdmin = async (dataIndex, newRoleId, rows) => {
    try {
      rows[dataIndex].roleId = newRoleId;

      // TODO: create new service updateAdministrator role
      await updateAdministrator(rows[dataIndex], rows);

      newRoleId === 0
        ? notifySuccess(
            rows[dataIndex].name + ' has been successfully removed from this Role'
          )
        : notifySuccess(
            rows[dataIndex].name + ' has been successfully added to this Role'
          );

      handleSearch(true);
    } catch (error) {
      notifyError(error.message);
      console.error(error);
    }
  };

  const [loading, setLoading] = React.useState(false);
  const [rows, setRows] = useState([]);
  const [searchData, setSearchData] = React.useState({
    name: '',
    email: '',
    userType: '',
    status: 'Active',
    roleId: 0,
    roleName: '',
  });

  useEffect(() => {
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e, x) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    if (['roleName'].includes(input.name)) {
      searchData.roleId = input.roleId;
      searchData.roleName = input.value;
    }

    setSearchData({
      ...searchData,
      [input.name]: input.value,
    });
  };

  const handleSearch = async (dontNotify) => {
    try {
      setLoading(true);

      const data = await listAdministrator(searchData);
      const rows = data.administratorsList.map((data) => ({
        usrId: data.usrId,
        roleName: data.roleName,
        roleId: data.roleId,
        name: data.name,
        email: data.email,
        createdAt: data.createdAt,
        access: data.access,
        // password: data.password,
        // passwordConfirm: data.password,
        defaultAccess: data.defaultAccess,
        mobileNo: data.mobileNo,
        userType: data.userType,
        status: data.status,
        admin: data.admin,
        correspondent: data.correspondent,
        authenticationMode: data.authenticationMode,
        secretKey: data.secretKey,
        authenticationText: data.authenticationMode.includes('Text'),
        authenticationEmail: data.authenticationMode.includes('Email'),
        authenticationAuthenticator: data.authenticationMode.includes('Authenticator'),
        modifiedBy: data.modifiedBy,
      }));
      setRows(rows);
      setRowsChecked(
        data.administratorsList.map((data) => {
          if (data.roleId === params.id) {
            return data.usrId;
          }
          return 0;
        })
      );
      if (!dontNotify) notifyInfo(data.administratorsList.length + ' search results.');
    } catch (error) {
      console.error(error);
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const getCsvData = async () => {
    if (rows.length === 0) {
      return [];
    }
    return rows;
  };

  return (
    <div className="page-c">
      <div className="search-c">
        <div className="grd-row nm">
          <div className="grd-cell"></div>
          <div className="grd-cell-none">
            <Button
              disabled={loading}
              loading={loading}
              type="search"
              label={loading ? 'Searching...' : 'Search'}
              onClick={handleSearch}
            />
          </div>
        </div>
        <div className="grd-row">
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <AutoCompleteAdministratorName
              name="name"
              label="User"
              freeSolo={true}
              value={searchData.name}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              onKeyDown={(e) => (e.keyCode === 13 ? handleSearch() : null)}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <AutoCompleteAdministratorEmail
              name="email"
              label="Email"
              freeSolo={true}
              value={searchData.email}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              onKeyDown={(e) => (e.keyCode === 13 ? handleSearch() : null)}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <SelectSystemCode
              name="userType"
              label="User Type"
              type="User Type"
              value={searchData.userType}
              onChange={handleChange}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <SelectRole
              name="roleName"
              label="Role Name"
              value={searchData.roleName}
              onChange={handleChange}
            />
          </div>
          <div className="grd-cell">
            <SelectSystemCode
              name="status"
              label="Status"
              type="Status"
              subType="AI"
              value={searchData.status}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
      <div className="mt-20">
        <div
          className="grd-cell"
          style={{
            textAlign: 'right',
            marginTop: 30,
            color: '#1e7dff',
          }}
        >
          <small>
            Changes will be saved automatically, but will reflect on next search.
          </small>
        </div>
        <ClientGrid
          title="Role Manager User"
          rowIdField="id"
          columns={columns}
          rows={rows}
          setRows={setRows}
          isLoading={loading}
          getCsvData={getCsvData}
          onSelectedRowsChange={(selectedRowsIds) => {
            setSelectedRowsIds(selectedRowsIds);
          }}
          selectedRowsIds={selectedRowsIds}
          rowsChecked={rowsChecked}
        />
      </div>
    </div>
  );
}
